(function(){
  'use strict';

  var LOGO_URL='https://cdn.shopify.com/s/files/1/0853/4009/4779/files/Nuvio-BLACK_b23ebc01-28ae-47fa-ae5d-76f186047f60.svg?v=1706175394';

  function applyLogo(scope){
    (scope||document).querySelectorAll('[data-nuvio-header] .nv-logo').forEach(function(link){
      link.setAttribute('href','/');
      link.setAttribute('aria-label','Nuvio home');

      var image=document.createElement('img');
      image.className='nv-logo-image';
      image.src=LOGO_URL;
      image.alt='Nuvio';
      image.width=130;
      image.height=45;
      image.loading='eager';
      image.decoding='sync';

      var fallback=document.createElement('span');
      fallback.className='nv-logo-wordmark';
      fallback.textContent='nuvio.';
      fallback.hidden=true;

      image.addEventListener('error',function(){
        image.hidden=true;
        fallback.hidden=false;
      });

      link.replaceChildren(image,fallback);
    });
  }

  function boot(){ applyLogo(document); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
  else boot();

  document.addEventListener('shopify:section:load',function(event){
    applyLogo(event.target);
  });
})();
